<div class="footer-container">
  <div class="social">
    <a angulartics2On="click"  href="https://twitter.com/goarmyedge" target="_blank"><img src="/assets/images/social/logo-white.png" alt=""></a>
    <a angulartics2On="click"  href="https://www.facebook.com/GoArmyEdgeFootball/" target="_blank"><img src="/assets/images/social/facebook-flat.svg" alt=""></a>
    <a angulartics2On="click"  href="https://www.youtube.com/goarmyedge" target="_blank"><img src="/assets/images/social/youtube-flat.svg" alt=""></a>
  </div>
  
  <div class="links">
    <a angulartics2On="click" routerLink="/privacy-policy">Privacy Policy</a>
    <a angulartics2On="click" routerLink="/terms-of-use">Terms Of Use</a>
    <a angulartics2On="click" routerLink="/eula">End User Licensing Agreement</a>
    <a angulartics2On="click" 
      href="mailto:support@goarmyedge.com?subject=Support%20for%20GoArmy%20Edge">Email Support</a>
  </div>
  
  <div class="copyright">
    <p>&copy;{{ copyrightDate }} U.S. Army</p>
  </div>  
</div>


